import { render } from "./Publications.vue.js?vue&type=template&id=c6d1eb92!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Publications.vue?vue&type=template&id=c6d1eb92"
import script from "./Publications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Publications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/Publications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6d1eb92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6d1eb92', __exports__)) {
    api.reload('c6d1eb92', __exports__)
  }
  
  module.hot.accept("./Publications.vue.js?vue&type=template&id=c6d1eb92!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Publications.vue?vue&type=template&id=c6d1eb92", () => {
    api.rerender('c6d1eb92', render)
  })

}


export default __exports__